export const inputNumberOnly = (e) => {
  const allowedChars = "0123456789";
  function contains(stringValue, charValue) {
    return stringValue.indexOf(charValue) > -1;
  }
  const invalidKey =
    (e.key.length === 1 && !contains(allowedChars, e.key)) ||
    (e.key === "." && contains(e.target.value, "."));
  return invalidKey && e.preventDefault();
};

export const inputNumberOnly3Digit = (e) => {
  const allowedChars = "0123456789";
  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

  // izinkan tombol navigasi
  if (allowedKeys.includes(e.key)) return;

  // blokir selain angka
  if (e.key.length === 1 && !allowedChars.includes(e.key)) {
    e.preventDefault();
    return;
  }

  // blokir jika sudah 3 digit
  if (e.target.value.length >= 3) {
    e.preventDefault();
  }
};

export const inputAlphabetOnly = (e) => {
  const allowedChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ ";
  function contains(stringValue, charValue) {
    return stringValue.indexOf(charValue) > -1;
  }
  const invalidKey =
    (e.key.length === 1 && !contains(allowedChars, e.key)) ||
    (e.key === "." && contains(e.target.value, "."));
  return invalidKey && e.preventDefault();
};
